export type YesNoMaybe = 'yes' | 'no' | 'maybe';

export function toYesNoMaybe(value?: boolean): YesNoMaybe {
    if (value === null) {
        return 'maybe';
    }

    return value ? 'yes' : 'no';
}